import type {SingleUsePaymentToken} from '../../../../../transport/types/checkout';

import type {ApplePayPayment} from './types';

/**
 * Build single_use_payment_token for checkout API
 *
 * Creates the token format expected by middleware → MFL:
 * {
 *   payment_service_id: 'apple-pay-service-id',
 *   token: '{"paymentData":...,"paymentMethod":...,"transactionIdentifier":...}'
 * }
 *
 * @param payment Apple Pay payment from onpaymentauthorized event
 * @param paymentServiceId Apple Pay service ID from backend config
 * @returns Token for apiService.checkoutOrder({ single_use_payment_token })
 */
export function buildSingleUsePaymentToken(
  payment: ApplePayPayment,
  paymentServiceId: string,
): SingleUsePaymentToken {
  return {
    payment_service_id: paymentServiceId,
    token: JSON.stringify(payment.token),
  };
}
